var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[(_vm.getWarnings.length > 0)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"mr-1",class:_vm.getCss,attrs:{"small":""}},'v-icon',attrs,false),on),[_vm._v(" mdi-alert ")])]}}],null,false,2955646379)},[_c('ul',_vm._l((_vm.getWarnings),function(warning,i){return _c('li',{key:i},[_vm._v(" "+_vm._s(warning)+" ")])}),0)]):_vm._e(),(_vm.isSearchMatchedOnHiddenField)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"blue--text mr-1",attrs:{"small":""}},'v-icon',attrs,false),on),[_vm._v(" mdi-information ")])]}}],null,false,3688932391)},[_vm._v(" Search match was made on another ranking url in the cluster ")]):_vm._e(),(_vm.keyword.correctPageId && _vm.keyword.correctPageSetType !== 4)?_c('div',[_c('UrlLink',{class:_vm.getLinkClass(),attrs:{"to":{
        name: 'checkList-page-keywords',
        params: {
          domain: _vm.domain,
          propertyId: _vm.propertyId,
          pageId: _vm.keyword.correctPageId,
          pageUrl: _vm.toHex(_vm.keyword.correctPageUrl),
        },
      },"url":_vm.keyword.correctPageUrl,"hoverUrl":_vm.keyword.variables.loadingFinalUrlInfo
          ? 'Loading...'
          : _vm.keyword.correctPageFinalUrl}})],1):(_vm.keyword.correctPageId && _vm.keyword.correctPageSetType == 4)?_c('div',[_c('router-link',{attrs:{"to":{
        name: 'checkList-draft-page-keywords',
        params: {
          domain: _vm.domain,
          propertyId: _vm.propertyId,
          draftPageId: _vm.keyword.correctPageId,
        },
      }}},[_vm._v(" "+_vm._s(_vm.keyword.correctPageUrl + " (draft page)")+" ")])],1):(_vm.keyword.trustedSuggestion)?_c('div',[_c('UrlLink',{attrs:{"to":{
        name: 'checkList-page-keywords',
        params: {
          domain: _vm.domain,
          propertyId: _vm.propertyId,
          pageId: _vm.keyword.trustedSuggestion.pageId,
          pageUrl: _vm.toHex(_vm.keyword.trustedSuggestion.url),
        },
      },"url":_vm.keyword.trustedSuggestion.url}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }